<template>
  <div class="e-checkbox">
    <div class="e-checkbox__holder">
      <label
        v-for="(filter, index) in allFilters"
        :key="index"
        :for="filter.value"
        class="e-checkbox__box"
        :class="{
          'e-checkbox__box--checked': selections.includes(filter.value),
        }">
        <input
          :id="filter.value"
          v-model="selections"
          :value="filter.value"
          :disabled="isDisabled(filter.value)"
          :checked="modelValue.includes(filter.value)"
          type="checkbox"
          @change="updateCheckall" />
        <span class="e-checkbox__text">{{ filter.display }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import { makeId } from '../../lib/lib'

export default {
  props: {
    modelValue: {
      default() {
        return []
      },
      type: Array,
    },
    filtered: {
      default() {
        return []
      },
      type: Array,
    },
    allGenres: {
      default: 'All',
      type: String,
    },
    allFilters: {
      default() {
        return []
      },
      type: Array,
    },
  },
  emits: ['filterChanged'],
  data() {
    return {
      inputId: makeId(),
      selections: [...this.modelValue],
      modelCheckAll:
        this.modelValue.length === 0 ||
        this.modelValue.length === this.filtered.length,
    }
  },
  computed: {
    allCheckedClass() {
      return this.isCheckAll ? 'e-checkbox__box--checked' : ''
    },
    isCheckAll() {
      return this.modelCheckAll
    },
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.selections = [...newVal]
      },
    },
  },
  methods: {
    async checkAll() {
      await this.$nextTick()

      if (this.isCheckAll) {
        this.selections = []
        // for (const key in this.filtered) {
        //   this.selections.push(this.filtered[key].value)
        // }
      }

      this.emitData()
    },
    async updateCheckall() {
      await this.$nextTick()

      if (
        this.selections.length === 0 ||
        this.selections.length === this.filtered.length
      ) {
        // this.selections = []
        // this.modelCheckAll = true
      } else {
        // this.modelCheckAll = false
      }
      this.emitData()
    },
    emitData() {
      this.$nextTick(() => {
        this.$emit('filterChanged', this.selections, 'genres')
      })
    },
    isDisabled(val) {
      const filter = this.allFilters.find((f) => f.value === val)
      return filter?.disabled === true
    },
  },
}
</script>
